import { useQuery } from "@tanstack/react-query";
import { getAuthorityHistory } from "@/Services/institutions.service";

export function useInstitutionAuthorityHistory(
  institutionId: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ["institution-authority-history", institutionId],
    queryFn: () => getAuthorityHistory(institutionId!),
    enabled: !!institutionId && enabled,
  });
}
